import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, "")}${path}`
  }
  return path
}

export interface EmailConfigDto {
  emailConfigId: string
  environmentCode: string
  smtpHost: string
  smtpPort: number
  senderEmail: string
  dnsBaseUrl?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

export interface EmailConfigUpsertRequest {
  environmentCode: string
  smtpHost: string
  smtpPort: number
  senderEmail: string
  dnsBaseUrl?: string | null
}

export async function getEmailConfig(environmentCode: string): Promise<EmailConfigDto | null> {
  const response = await axios.get<EmailConfigDto>(buildUrl("/api/v1/email-configs"), {
    params: { environment: environmentCode },
    validateStatus: (status) => status >= 200 && status < 300 || status === 404,
  })
  if (response.status === 404) {
    return null
  }
  return response.data
}

export async function upsertEmailConfig(payload: EmailConfigUpsertRequest): Promise<EmailConfigDto> {
  const response = await axios.post<EmailConfigDto>(buildUrl("/api/v1/email-configs"), payload)
  return response.data
}
